<mat-form-field appearance="outline" subscriptSizing="dynamic">
  @if (label()) {
    <mat-label>{{ label() }}</mat-label>
  }

  <!-- Read-only: the day is picked in the calendar, which also opens on a click anywhere in the field. -->
  <input
    matInput
    readonly
    [matDatepicker]="picker"
    [value]="date()"
    [min]="minDate()"
    [max]="maxDate()"
    [matDatepickerFilter]="dateFilter()"
    [disabled]="disabled()"
    [placeholder]="placeholder()"
    [attr.aria-label]="ariaLabel() || null"
    (dateChange)="onDateChange($event.value)"
    (click)="picker.open()"
  />

  @if (clearable() && value() && !disabled()) {
    <button
      matIconSuffix
      type="button"
      class="bz-date-picker__clear"
      [attr.aria-label]="clearLabel()"
      (click)="clear($event)"
    >
      <bz-icon [icon]="clearIcon" size="sm" />
    </button>
  }

  <mat-datepicker-toggle matIconSuffix [for]="picker" [disabled]="disabled()" [aria-label]="openLabel()">
    <bz-icon matDatepickerToggleIcon [icon]="calendarIcon" size="lg" />
  </mat-datepicker-toggle>

  <mat-datepicker #picker panelClass="bz-date-picker-panel" />
</mat-form-field>
